module.exports = __webpack_public_path__ + "static/img/videoCover3.3fc3d263.png";